export enum ErrorKeys {
  NOT_FOUND_PROJECT = 'not_found_project',
  GENERAL_API_ERROR = 'general_api_error',
  PROJECT_MAX_DURATION_EXCEEDED = 'project_max_duration_exceeded',
  AI_VIDEO_GENERATION_FAILED = 'ai_video_generation_failed',
  AI_IMAGE_GENERATION_FAILED = 'ai_image_generation_failed',
  AI_MODERATION_FAILED = 'ai_moderation_failed',
  CUSTOM_API_ERROR = 'custom_api_error'
}
